import React from 'react'

import HeroBase from './HeroBase'
import Breadcrumbs from './Breadcrumbs'

const HeroProvider = ({ apidoc = {}, intents = [] }) => {
    const { vendor = '', name, version } = apidoc

    return (
        <HeroBase center>
            <div className="header__breadcrumbs">
                {intents.length < 1 && <span>&nbsp;</span>}
                {intents.map((intent, idx) => (
                    <Breadcrumbs intent={intent} key={idx} long />
                ))}
            </div>
            <h1 className="hero__title h1">{vendor || <span>&nbsp;</span>}</h1>
            <p className="hero__text">
                {name || <span>&nbsp;</span>}
                {version && ` v${version}`}
            </p>
        </HeroBase>
    )
}

export default HeroProvider



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/HeroProvider.jsx